class WrProductFeature extends HTMLElement {
  connectedCallback() {
    this.hotspots = this.querySelectorAll('[data-hotspot]');
    this.slideshow = this.querySelector('swiper-slideshow');

    if (!this.hotspots.length || !this.slideshow) return;

    this.hotspots.forEach((hotspot) => {
      hotspot.addEventListener('click', () => {
        const index = parseInt(hotspot.dataset.hotspotIndex, 10);
        this.slideshow.slideTo(index);
      });
    });

    this.waitForSwiper().then((swiper) => {
      swiper.el.style.removeProperty('height');

      this.syncHotspots(swiper.activeIndex);
      this.syncSlideVisibility(swiper);

      this.slideshow.addEventListener('swiper:slideChange', (event) => {
        const activeSwiper = event.detail.swiper;
        this.syncHotspots(activeSwiper.activeIndex);
        this.syncSlideVisibility(activeSwiper);
      });
    });
  }

  waitForSwiper() {
    return new Promise((resolve) => {
      const check = () => {
        const swiper = this.slideshow.getSwiper?.();
        if (swiper) {
          resolve(swiper);
        } else {
          setTimeout(check, 50);
        }
      };
      check();
    });
  }

  syncHotspots(index) {
    this.hotspots.forEach((hotspot) => {
      const isActive = parseInt(hotspot.dataset.hotspotIndex, 10) === index;
      hotspot.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      hotspot.classList.toggle('wr-hotspot--active', isActive);
    });
  }

  syncSlideVisibility(swiper) {
    swiper.slides.forEach((slide, index) => {
      const isActive = index === swiper.activeIndex;
      slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });
  }
}

customElements.define('wr-product-feature', WrProductFeature);
